import View from './index.vue';
import { withInstall } from './../../utils/install';
export const TIcon = withInstall(View);
export default TIcon;
